import { gql } from '@apollo/client'
import { AddressFragment } from '../fragments/address.fragments'

export const BestPracticeQuery = gql`
    query bestPracticeQuery($parentId: String!, $projectId: String!) {
        getBestPractice(parentId: $parentId, projectId: $projectId) {
            id
            firmId
            isGlobal
            parentProjectId
            projectElementNodeId
            contentItemId
            location {
                ...addressFragment
            }
            projectGroup
            parameters {
                selectedModifiers {
                    name
                }
                modifierList {
                    name
                }
            }
            isUserAddedContentBestPractice
        }
    }
    ${AddressFragment}
`
